import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule, UrlSerializer} from '@angular/router';
import {routes} from './app.routes';
import {AlertComponent} from './components/alerts/alert/alert.component';
import {AlertsComponent} from './components/alerts/alerts.component';
import {AppRootComponent} from './components/app-root/app-root.component';
import {CheckInternetConnectionComponent} from './components/check-internet-connection/check-internet-connection.component';
import {FakeIntercomComponent} from './components/fake-intercom/fake-intercom.component';
import {FinishDemoButtonComponent} from './components/finish-demo-button/finish-demo-button.component';
import {InternalServerErrorComponent} from './components/internal-server-error/internal-server-error.component';
import {LanguageSwitcherComponent} from './components/language-switcher/language-switcher.component';
import {ModernLayoutComponent} from './components/modern-layout/modern-layout.component';
import {NavigationSideBarComponent} from './components/navigation-side-bar/navigation-side-bar.component';
import {NavigationToggleComponent} from './components/navigation-toggle/navigation-toggle.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {SignOutComponent} from './components/sign-out/sign-out.component';
import {UserBarComponent} from './components/user-bar/user-bar.component';
import {CoreModule} from './core/core.module';
import {FinishDemoDirective} from './directives/finish-demo.directive';
import {SharedModule} from './shared/shared.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {LayoutSwitcherService} from 'app/features/analytics/guards/layout-switcher.service';
import {TransitionResetDirective} from './directives/transition-reset.directive';
import {LeaveDemoAccountComponent} from './components/leave-demo-account/leave-demo-account.component';
import {DefaultMainPageComponent} from 'app/components/default-main-page/default-main-page.component';
import {SettingsPageComponent} from 'app/components/settings-page/settings-page.component';
import {FooterComponent} from './components/footer/footer.component';
import {CustomUrlSerializer} from './features/iframe-pages/custom-url-serializer';
import {AppNewReleaseResolver} from 'app/features/apps/resolvers/app-new-release.resolver';
import {AppNewReleaseNotifierService} from 'app/features/apps/services/app-new-release-notifier.service';
import {NotificationsComponent} from './components/notifications/notifications.component';
import {NotificationsService} from 'app/core/services/notifications/notifications.service';
import {NotificationBannerComponent} from './components/notifications/notification-banner/notification-banner.component';
import {PreviewPageComponent} from 'app/features/notifications/preview-page/preview-page.component';
import {ToastrModule} from 'ngx-toastr';
import {ToastrAlertsService} from 'app/core/services/alerts/toastr-alerts.service';
import {BreadcrumbService} from './core/services/breadcrumb.service';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        RouterModule.forRoot(routes, {
            enableTracing: false,
            onSameUrlNavigation: 'reload',
            urlUpdateStrategy: 'deferred',
            scrollPositionRestoration: 'disabled',
        }),
        ToastrModule.forRoot(),
        // TODO: uncomment when DCC frontend completely move to angular
        // ServiceWorkerModule.register('/ngsw-worker.js', {enabled: environment.production}),
        CoreModule,
        SharedModule,
        DragDropModule,
    ],
    declarations: [
        AppRootComponent,
        NavigationSideBarComponent,
        AlertsComponent,
        AlertComponent,
        FakeIntercomComponent,
        SignOutComponent,
        InternalServerErrorComponent,
        CheckInternetConnectionComponent,
        PageNotFoundComponent,
        NavigationToggleComponent,
        LanguageSwitcherComponent,
        UserBarComponent,
        FinishDemoButtonComponent,
        ModernLayoutComponent,
        DefaultMainPageComponent,
        FinishDemoDirective,
        TransitionResetDirective,
        LeaveDemoAccountComponent,
        SettingsPageComponent,
        FooterComponent,
        NotificationsComponent,
        NotificationBannerComponent,
        PreviewPageComponent,
    ],
    bootstrap: [AppRootComponent],
    providers: [
        LayoutSwitcherService,
        {provide: UrlSerializer, useClass: CustomUrlSerializer},
        AppNewReleaseResolver,
        AppNewReleaseNotifierService,
        NotificationsService,
        ToastrAlertsService,
        BreadcrumbService,
    ],
})
export class AppModule {}
